const PAIN_POINTS = [
  {
    icon: "ri-timer-line",
    text: "공부하고 싶은 마음은 있는데 막상 시작이 어렵다.",
  },
  {
    icon: "ri-emotion-sad-line",
    text: "독학을 시작해도 오래가기 어렵다. ",
  },
  {
    icon: "ri-question-mark",
    text: "맞게 배우고 있는지 확신이 없다.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    text: "학원은 시간과 비용이 부담된다.",
  },
  {
    icon: "ri-chat-off-line",
    text: "문법은 아는데 여행에서는 말이 안 나온다.",
  },
];

export default function Empathy() {
  return (
    <section id="empathy" className="py-10 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        <div className="text-center mb-10">
          <span className="text-[10px] md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            Pain Points
          </span>
          <h2 className="mt-3 font-heading text-xl md:text-4xl font-bold text-foreground-950">
            일본어, 이런 고민이 있으셨나요?
          </h2>
        </div>

        <div className="max-w-xl mx-auto space-y-3">
          {PAIN_POINTS.map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-4 bg-background-50 border border-background-200 rounded-xl px-4 py-3 sm:px-6 sm:py-4"
            >
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                <i className={`${item.icon} text-base sm:text-lg`}></i>
              </div>
              <p className="text-sm sm:text-base font-medium text-foreground-800">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <div className="inline-flex items-center gap-3">
            <div className="h-px w-10 sm:w-16 bg-primary-300"></div>
            <span className="text-sm sm:text-base font-semibold text-primary-600 whitespace-nowrap">
              그래서 실전 일본어 연구소를 만들었습니다.
            </span>
            <div className="h-px w-10 sm:w-16 bg-primary-300"></div>
          </div>
        </div>
      </div>
    </section>
  );
}